import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createSlots as _createSlots, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import type { Raw } from 'vue'
import { useWait } from '@/app/composables/useWait'

import type { UserDocListItem } from '@/models/interfaces'
import { toggleDocFavorite } from '@/models/doc.favorite'
import { DocCustomListsView } from '@/models/doc.custom.lists'
import type { DocsView } from '@/models/doc'

import ActionMenu from '@/app/components/ActionMenu.vue'
import Action from '@/app/components/ActionMenuItem.vue'
import AddToListPopup from './AddToListPopup.vue'
import IconButton from '@/app/components/button/IconButton.vue'

/**
 * This component is a wrapper on top of `ActionMenu` with
 * actions for adding the doc to Favorites and moving it
 * between Custom Lists.
 *
 * @param doc - The doc upon which these actions will take effect.
 * @param docsView - For updating the list when adding / removing docs from lists.
 * @param position - The dropdown menu position.
 * @param iconSize - The font size of the button.
 * @param useIconButton - Whether or not to use the IconButton component for the toggle button.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'DocListsMenu',
  props: {
    doc: {},
    docsView: {},
    position: { default: 'right' },
    iconSize: { default: 'normal' },
    useIconButton: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const wait = useWait()
const addToListPopup = ref<InstanceType<typeof AddToListPopup> | null>(null)

const view = ref<Raw<DocCustomListsView>>(
  new DocCustomListsView(props.doc, wait, props.docsView),
)

async function toggleFavorite(): Promise<void> {
  toggleDocFavorite(props.doc, props.docsView)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ActionMenu, _mergeProps({
      class: ["doc-lists-menu", { 'doc-lists-menu--marked': view.value.isDocInAnyList }],
      position: __props.position,
      iconSize: __props.iconSize,
      icon: view.value.isDocInAnyList ? 'iflag2' : 'iflag'
    }, _ctx.$attrs), _createSlots({
      default: _withCtx(() => [
        _createVNode(Action, {
          class: "doc-lists-menu--favorite",
          icon: __props.doc.user.is_favorite ? 'ifavorite-remove' : 'icontrol-favorite',
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleFavorite()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.doc.user.is_favorite ? 'Remove from Favorites' : 'Add to Favorites'), 1)
          ]),
          _: 1
        }, 8, ["icon"]),
        (__props.doc.doc_type === 'book')
          ? (_openBlock(), _createBlock(Action, {
              key: 0,
              class: "doc-lists-menu--want-to-read",
              icon: view.value.isInWantToRead ? 'iflag-remove' : 'iflag',
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (view.value.toggleWantToRead()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(view.value.isInWantToRead ? 'Remove from Want to Read' : 'Add to Want to Read'), 1)
              ]),
              _: 1
            }, 8, ["icon"]))
          : _createCommentVNode("", true),
        (__props.doc.doc_type === 'book')
          ? (_openBlock(), _createBlock(Action, {
              key: 1,
              class: "doc-lists-menu--add-to-list",
              icon: "iplayer-fast",
              onClick: _withModifiers(addToListPopup.value?.show, ["prevent"])
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Add to List ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (__props.useIconButton)
        ? {
            name: "button",
            fn: _withCtx(() => [
              _createVNode(IconButton, {
                icon: view.value.isDocInAnyList ? 'iflag2' : 'iflag',
                tooltip: "Add / Remove from lists",
                outlined: ""
              }, null, 8, ["icon"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["position", "iconSize", "class", "icon"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
      _createVNode(AddToListPopup, {
        ref_key: "addToListPopup",
        ref: addToListPopup,
        view: view.value
      }, null, 8, ["view"])
    ]))
  ], 64))
}
}

})